import configData from "../config.json";
import React from "react";
import { setUserSession } from "../components/Session";
import SlideButton from "react-slide-button";
import biglogo from "../assets/biglogo.png";

const SignIn = () => {
    let u = localStorage.getItem("WBU") || "";
    let p = localStorage.getItem("WBP") || "";
    const [username, setUsername] = React.useState(u);
    const [password, setPassword] = React.useState(p);
    const [fail, setFail] = React.useState(false);
    const [reset, setReset] = React.useState(0);
    const [theme, setTheme] = React.useState("dark"); // "light" or "dark"
    const [loginSuccess, setLoginSuccess] = React.useState(false);
    const [showPassword, setShowPassword] = React.useState(false);
    const [confettiPieces, setConfettiPieces] = React.useState([]);

    React.useEffect(() => {
        if (u !== "" && p !== "") {
            submitted();
        }
    }, []);

    const spawnConfetti = () => {
        const pieces = Array.from({ length: 20 }).map(() => ({
            id: Math.random().toString(36).substr(2, 9),
            left: Math.random() * 320 + "px",
            animationDelay: Math.random() + "s",
            backgroundColor: `hsl(${Math.random() * 360}, 80%, 60%)`,
        }));
        setConfettiPieces(pieces);
        setTimeout(() => setConfettiPieces([]), 1600);
    };

    const submitted = async () => {
        try {
            var url = `${configData.SERVER_URL}apiV7/Auth`;

            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                mode: "cors",
                body: JSON.stringify({
                    username,
                    password,
                }),
            });

            if (response.ok) {
                setFail(false);
                setLoginSuccess(true);
                spawnConfetti(); // trigger confetti on success!
                const data = await response.json();
                setUserSession(data);
                if (data.autologin) {
                    localStorage.setItem("WBU", username);
                    localStorage.setItem("WBP", password);
                } else {
                    localStorage.setItem("WBU", "");
                    localStorage.setItem("WBP", "");
                }
                setTimeout(() => {
                    window.location.href = data.initialPage;
                }, 1500);
            } else {
                setFail(true);
                localStorage.setItem("WBU", "");
                localStorage.setItem("WBP", "");
                setReset((counter) => counter + 1);
				console.error("Login failed");
				// return back to start
				setTimeout(() => {

					setFail(false);

				}, 2000);
            }
        } catch (error) {
            setReset((counter) => counter + 1);
            console.error("Login error:", error);
        }
    };

    const toggleTheme = () => {
        setTheme((curr) => (curr === "dark" ? "light" : "dark"));
    };

    const toggleShowPassword = () => {
        setShowPassword((v) => !v);
    };

    return (
        <>
            <style>{`
        * {
	box-sizing: border-box;
}

body,
html,
#root {

	margin: 0;
	padding: 0;
	height: 100vh;

	font-family: 'Poppins', sans-serif;

	display: flex;
	justify-content: center;
	align-items: center;

	overflow: hidden;
}

/* Background */

.background {
	position: fixed;
	inset: 0;
	z-index: -1;
}

.background.dark {

	background:
		radial-gradient(circle at top left,
			rgba(255, 205, 0, .15),
			transparent 35%),

		radial-gradient(circle at bottom right,
			rgba(11, 94, 59, .25),
			transparent 40%),

		linear-gradient(135deg,
			#052e1f,
			#083d27,
			#0b5e3b);
}

.background.light {

	background:
		linear-gradient(135deg,
			#f5f5f5,
			#ececec);
}

/* Login Card */

.form-container {

	width: 430px;
	max-width: 92vw;

	padding: 40px;

	border-radius: 28px;

	display: flex;
	flex-direction: column;
	align-items: center;

	position: relative;

	transition: .3s;
}

.form-container.dark {

	background:
		rgba(255, 255, 255, .08);

	border:
		1px solid rgba(255, 255, 255, .15);

	backdrop-filter:
		blur(20px);

	-webkit-backdrop-filter:
		blur(20px);

	box-shadow:
		0 30px 60px rgba(0, 0, 0, .45);

	color: white;
}

.form-container.light {

	background: white;

	color: #222;
}


/* Logo */

.logo {

	width: 180px;

	margin-bottom: 20px;

	filter:
		drop-shadow(0 5px 15px rgba(0, 0, 0, .35));
}

/* Title */

h1 {

	margin: 0 0 25px;

	color: white;

	font-size: 34px;

	font-weight: 800;

	letter-spacing: 1px;
}

/* Inputs */

input[type="text"],
input[type="password"] {
	margin-bottom: 18px;


	width: 100%;

	padding: 16px 18px;

	border-radius: 14px;

	font-size: 15px;

	border:
		1px solid rgba(255, 205, 0, .25);

	background:
		rgba(255, 205, 0, .08);

	color: white;

	transition: .3s;
}

input::placeholder {
	color: #d1d5db;
}

input:focus {

	outline: none;

	border-color: #FFCD00;

	box-shadow:
		0 0 0 4px rgba(255, 205, 0, .15);
}

/* Password */

.password-wrapper {
	width: 100%;
	position: relative;
}

.toggle-password {

	position: absolute;

	top: 50%;
	right: 16px;

	transform:
		translateY(-50%);

	cursor: pointer;

	font-size: 20px;

	color: #FFCD00;
}

/* Error */

.error-msg {

	color: #ff6b6b;

	font-size: 14px;

	margin-top: -10px;
	margin-bottom: 15px;

	font-weight: 700;
}

/* Slide Area */

.slide-container {

	width: 100%;

	margin-top: 5px;

	position: relative;
}

/* Football Slider */

.slide-submit {

	background:
		linear-gradient(135deg,
			#0B5E3B,
			#083D27) !important;

	border:
		2px solid rgba(255, 205, 0, .2);

	border-radius: 50px !important;

	overflow: hidden;

	position: relative;
}

/* Grass Strip */

.slide-submit::after {

	content: "";

	position: absolute;

	left: 0;
	bottom: 0;

	width: 100%;
	height: 8px;

	background:
		repeating-linear-gradient(90deg,
			#16a34a,
			#16a34a 10px,
			#15803d 10px,
			#15803d 20px);
}

/* Slider Text */

.slide-submit .slider-text {

	color: #FFCD00 !important;

	font-size: 16px;

	font-weight: 700;

	letter-spacing: .04em;
}

.slide-submit .slider-text--overlay {

	color: white !important;

	font-weight: 700;
}

/* Football Caret */

.slide-submit .slider-caret {

	border: none !important;

	border-radius: 50% !important;

	background: white !important;

	box-shadow:
		0 0 25px rgba(255, 205, 0, .45);

	transition: .3s;
}

.slide-submit .slider-caret:hover {

	box-shadow:
		0 0 35px rgba(255, 205, 0, .7);
}

.slide-submit .slider-caret::before {

	content: "⚽";

	display: flex;

	align-items: center;
	justify-content: center;

	width: 100%;
	height: 100%;

	font-size: 26px;
}

/* Success */

.button-text{

    position:absolute;

    left:50%;

    top:50%;

    transform:translate(-50%,-50%);


    z-index:20;


    font-size:16px;

    font-weight:800;


    color:#FFCD00;


    white-space:nowrap;

    pointer-events:none;

}


/* After goal */

.success .button-text{

    color:#083D27;

    text-shadow:

    0 0 10px rgba(255,255,255,.5);

}


/* After save */

.fail .button-text{

    color:white;

    text-shadow:

    0 0 10px rgba(0,0,0,.5);

}



/* Success message */

.fade-in-success{

    margin-top:20px;


    color:#FFCD00;


    font-size:22px;


    font-weight:900;


    text-align:center;


    text-shadow:

    0 0 20px rgba(255,205,0,.8);


    animation:

    fadeInScale 1s ease forwards;

}



@keyframes fadeInScale{


from{

opacity:0;

transform:scale(.85);

}


to{

opacity:1;

transform:scale(1);

}


}

/* Confetti */

.confetti-container {

	position: absolute;

	inset: 0;

	pointer-events: none;
}

.confetti {

	position: absolute;

	width: 8px;
	height: 8px;

	border-radius: 2px;

	animation:
		confetti-fall 1.5s ease forwards;
}

@keyframes confetti-fall {

	from {
		opacity: 1;
		transform:
			translateY(0) rotate(0deg);
	}

	to {
		opacity: 0;
		transform:
			translateY(90px) rotate(360deg);
	}
}

/* Footer */

footer {

	position: fixed;

	bottom: 15px;

	left: 0;
	right: 0;

	text-align: center;

	color: white;
}

footer a {

	color: white;

	text-decoration: none;

	transition: .3s;
}

footer a:hover {

	color: #FFCD00;
}

/* Theme Toggle */

.theme-toggle {

	position: fixed;

	top: 20px;
	right: 20px;

	width: 50px;
	height: 50px;

	border-radius: 50%;

	border:
		1px solid rgba(255, 255, 255, .2);

	background:
		rgba(255, 255, 255, .08);

	color: white;

	cursor: pointer;
}

.football-login-wrapper {
	width: 100%;

	position: relative;

	margin-top: 20px;
}

.football-btn {

	width: 100%;

	height: 80px;

	border: none;

	border-radius: 50px;

	cursor: pointer;

	overflow: hidden;

	position: relative;

	display: flex;

	align-items: center;

	justify-content: center;


	background:
		linear-gradient(135deg,
			#0B5E3B,
			#083D27);


	border:
		2px solid rgba(255, 205, 0, .25);


	color: white;

	transition: .4s;
}

.football-btn:hover {
	transform: translateY(-2px);
}

.grass {

	position: absolute;


	bottom: 0;


	left: 0;


	width: 100%;


	height: 8px;


	z-index: 6;


	background:

		repeating-linear-gradient(90deg,

			#16a34a,

			#16a34a 10px,

			#15803d 10px,

			#15803d 20px);
}

.ball {

	position: absolute;


	left: 18px;


	top: 50%;


	transform: translateY(-50%);


	font-size: 32px;


	z-index: 2;


	transition:

		left 1.2s cubic-bezier(.22, .61, .36, 1);
}

.ball-goal {
	left: calc(100% - 70px);
}

.ball-save {
	left: 70%;
}

.status {

	position: absolute;


	left: 50%;


	top: 50%;


	transform:

		translate(-50%, -50%);


	z-index: 10;


	font-size: 16px;


	font-weight: 800;


	color: #FFCD00;


	white-space: nowrap;


	pointer-events: none;
}

.goal {

	position: absolute;


	right: 18px;


	top: 50%;


	transform: translateY(-50%);


	font-size: 30px;


	z-index: 4;
}

.keeper {

	position: absolute;


	right: 65px;


	top: 50%;


	transform: translateY(-50%);


	font-size: 26px;


	z-index: 5;


	animation:

		keeperAppear .3s ease;
}

@keyframes keeperAppear {


	from {


		opacity: 0;


		transform:

			translateY(-50%) scale(.7);


	}


	to {


		opacity: 1;


		transform:

			translateY(-50%) scale(1);


	}


}

.success {

	background:

		linear-gradient(135deg,

			#FFCD00,

			#FFD84D) !important;


	color: #083D27;


	box-shadow:

		0 0 35px rgba(255, 205, 0, .7);
}

.fail {
	background:

		linear-gradient(135deg,

			#dc2626,

			#ef4444) !important;

}

.shake {

	animation: shake .4s;

}


@keyframes shake {


	0%,
	100% {

		transform: translateX(0);

	}


	25% {

		transform: translateX(-4px);

	}


	50% {

		transform: translateX(4px);

	}


	75% {

		transform: translateX(-4px);

	}


}
      `}</style>

            {/* Background gradient */}
            <div className={`background ${theme}`} />

            {/* Theme toggle button with icons */}
            <button
                className={`theme-toggle ${theme === "light" ? "light" : ""}`}
                onClick={toggleTheme}
                aria-label="Toggle light/dark theme"
                title={theme === "dark" ? "Switch to Light Mode" : "Switch to Dark Mode"}
            >
                {theme === "dark" ? "🌞" : "🌜"}
            </button>

            {/* Form container */}
            <div className={`form-container ${theme}`}>
                <img src={biglogo} alt="EZYweigh" className="logo" />
                <h1>Secure Access</h1>
                <input
                    required
                    type="text"
                    placeholder="Username"
                    name="username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    autoComplete="username"
                />
                <div className="password-wrapper">
                    <input
                        required
                        type={showPassword ? "text" : "password"}
                        placeholder="Password"
                        name="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        autoComplete="current-password"
                    />
                    <span
                        className="toggle-password"
                        onClick={toggleShowPassword}
                        role="button"
                        aria-label={showPassword ? "Hide password" : "Show password"}
                        tabIndex={0}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                                toggleShowPassword();
                            }
                        }}
                    >
                        {showPassword ? "🙈" : "👁️"}
                    </span>
                </div>
                {fail}
                <div className="football-login-wrapper">

                    <button
                        className={`football-btn ${loginSuccess
                                ? "success"
                                : fail
                                    ? "fail shake"
                                    : ""
                            }`}
                        onClick={submitted}
                    >

                        <div className="grass"></div>

                        <span
                            className={`ball ${loginSuccess
                                    ? "ball-goal"
                                    : fail
                                        ? "ball-save"
                                        : ""
                                }`}
                        >
                            ⚽
                        </span>

						<span className="button-text">

							{loginSuccess
								? "⚽ GOAL! Welcome"
								: fail
									? "🧤 MISSED! Try Again"
									: "Kick (Click) To Login"}

						</span>

                        <span className="goal">
                            🥅
                        </span>

                        {fail && (
                            <span className="keeper">
                                🧤
                            </span>
                        )}

                    </button>

                    <div className="confetti-container">
                        {confettiPieces.map(
                            ({
                                id,
                                left,
                                animationDelay,
                                backgroundColor,
                            }) => (
                                <div
                                    key={id}
                                    className="confetti"
                                    style={{
                                        left,
                                        animationDelay,
                                        backgroundColor,
                                    }}
                                />
                            )
                        )}
                    </div>

                </div>
            </div>

            <footer>
                <p>
                    <a href="https://wms.screenconnect.com" target="_blank" rel="noreferrer">
                        <b>Remote support</b>
                    </a>
                    &nbsp;&nbsp;&nbsp;
                    <a href="https://weigh-more.com.au/contact/" target="_blank" rel="noreferrer">
                        <b>Contact us</b>
                    </a>
                    &nbsp;&nbsp;&nbsp;
                    <a href="https://weigh-more.com.au/about-us/" target="_blank" rel="noreferrer">
                        <b>About</b>
                    </a>
                </p>
            </footer>
        </>
    );
};

export default SignIn;
